import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const beneficiaryRoutes: MenuInterface[] = [
    {
        code: 'GestionBenefListe_ViewModel_Vup',
        route: [{
            content: 'beneficiary/edit-routing',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionBenefFicheSignaletique_ViewModel',
        route: [{
            content: 'beneficiary/detail',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionDossierBenefNew_ViewModel',
        route: [{
            content: 'beneficiary/edit-routing',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionDossierBenefNew_ViewModel',
        route: [{
            content: 'beneficiary/edit',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionBenefGererIdentifiant_ViewModel',
        route: [{
            content: 'beneficiary/credentials',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionParamValeurPossibleChp_ViewModel',
        route: [{
            content: 'beneficiary/parameters/field-value/list',
            focus: 'beneficiary/parameters/field-value/informations'
        }, 'content']
    },
    {
        code: 'GestionRecherchePieceJustificative_ViewModel',
        route: [{
            content: 'beneficiary/vouchers/list',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionHistoriqueModificationBenef_ViewModel',
        route: [{
            content: 'beneficiary/updates-history/list',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionBeneficiaireParamPJ_ViewModel',
        route: [{
            content: 'beneficiary/parameters/vouchers/list',
            focus: 'empty'
        }, {
            primaryRoute: 'content',
            queryParams: {closeButton: 1}
        }]
    },
    {
        code: 'GestionBeneficiaireAnneeReference_ViewModel',
        route: [{
            content: 'beneficiary/parameters/reference-years/list',
            focus: 'beneficiary/parameters/field-value/informations'
        }, 'content']
    },
    {
        code: 'GestionOrganisation_ViewModel',
        route: [{
            content: 'beneficiary/parameters/organization/list',
            focus: 'beneficiary/parameters/organization/informations'
        }, 'content']
    },
    {
        code: 'GestionChampPersoBenef_ViewModel',
        route: [{
            content: 'beneficiary/parameters/custom-fields/list',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionSite_ViewModel',
        route: [{
            content: 'beneficiary/parameters/beneficiary-parameters-sites/list',
            focus: 'beneficiary/parameters/beneficiary-parameters-sites/informations'
        }, 'content']
    },
    {
        code: 'GestionCriteresSociaux_ViewModel',
        route: [{
            content: 'beneficiary/parameters/social-criteria',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionRGPDSARM_ViewModel',
        route: [{
            content: 'beneficiary/rgpd-export/detail',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionRequeteurBenef_ViewModel',
        route: [{
            content: 'contact/request/export-beneficiary-list',
            focus: 'empty'
        }, {
            primaryRoute: 'content',
            queryParams: {beneficiaryRequest: 1}
        }]
    },
    {
        code: 'GestionConsultationCompteursPoints_ViewModel',
        route: [{
            content: 'beneficiary/point/point-counter/list',
            focus: 'empty'
        }, {
            primaryRoute: 'content',
            queryParams: { initialNavigation: 1 }
        }]
    },
    {
        code: 'GestionHistoPoints_ViewModel',
        route: [{
            content: 'beneficiary/point/point-history/list',
            focus: 'empty'
        }, {
            primaryRoute: 'content',
            queryParams: { initialNavigation: 1 }
        }]
    },
    {
        code: 'GestionHistoImports_Viewmodel',
        route: [{
            content: 'beneficiary/rh-reporting/list',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionModelesImports_Viewmodel',
        route: [{
            content: 'beneficiary/rh-reporting/imports/list',
            focus: 'empty'
        }, {
            primaryRoute: 'content',
            queryParams: { closeButton: 1 }
        }]
    },
    {
        code: 'GestionBenefListe_ViewModel_Vup',
        route: [{
            content: 'beneficiary/detail',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionVuesBenef_ViewModel',
        route: [
            {
                content: 'beneficiary/parameters/view/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionParamEtiquette_ViewModel_Vup',
        route: [
            {
                content: 'beneficiary/sheets/sheets-models/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: 1}
            }
        ]
    },
    {
        code: 'GestionParamEnvoiEtiquette_ViewModelVup',
        route: [
            {
                content: 'beneficiary/sheets/print',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'Module_PortailGestionInscription',
        route: [
            {
                content: 'beneficiary/online-registration/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionGroupe_ViewModel',
        route: [{
            content: 'beneficiary/parameters/groups/list',
            focus: 'empty'
        }, 'content']
    },
    {
        code: 'GestionConsultationSynchro_ViewModel',
        route: [
            {
                content: 'beneficiary/parameters/synchronization/list',
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'GestionConsultationSynchroSynapse_ViewModel',
        route: [
            {
                content: 'beneficiary/parameters/synchronization-synapse/list',
                focus: 'empty'
            }, 'content'
        ]
    }
];
